<template>
  <el-dialog
    top="10vh"
    width="1200px"
    :title="'【' + orderInfo.sn + '】' + '详情'"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    @close="closeDetail">
    <div class="content" v-loading="fetchLoading">
      <el-collapse v-model="openList">
        <el-collapse-item name="storeInfo">
          <template slot="title">
            <div class="title-text">
              <span class="title-item">货品信息</span>
              <span style="color: #000" class="title-item">总件数：{{initCount}}件</span>
            </div>
          </template>
          <div>
            <grid-manager :option="gridOption"></grid-manager>
          </div>
        </el-collapse-item>

        <el-collapse-item name="orderInfo" v-if="detailData.orderInfo">
          <template slot="title">
            <div>
              <span class="title-text">单据信息</span>
            </div>
          </template>
          <div class="order-info">
            <div class="order-info-item">
              <span class="order-info-label">本单金额：</span>
              <span class="red-text">***</span>
            </div>
            <div class="order-info-item">
              <span class="order-info-label">零售金额：</span>
              <span class="red-text">***</span>
            </div>
            <div class="order-info-item">
              <span class="order-info-label">已收金额：</span>
              <span class="red-text">***</span>
            </div>
            <div class="order-info-item" v-if="detailData.orderInfo.discountAmount">
              <span class="order-info-label">活动金额：</span>
              <span class="red-text">***</span>
            </div>
            <div class="order-info-item" v-if="detailData.orderInfo.changePrice">
              <span class="order-info-label">变动金额：</span>
              <span class="red-text">***</span>
            </div>
            <div class="order-info-item">
              <span class="order-info-label">销售状态：</span>
              <span v-if="detailData.orderInfo.state === '-1'">已取消</span>
              <span v-if="detailData.orderInfo.state === '1'">待支付</span>
              <span v-if="detailData.orderInfo.state === '2'">支付中</span>
              <span v-if="detailData.orderInfo.state === '3'">已支付</span>
              <span v-if="detailData.orderInfo.state === '4'">待审批</span>
              <span v-if="detailData.orderInfo.state === '5'">已作废</span>
            </div>
            <div class="order-info-item">
              <span class="order-info-label">店铺名称：</span>
              <span>{{ detailData.orderInfo.deptName }}</span>
            </div>
            <div class="order-info-item" v-if="detailData.orderInfo.giftDetail">
              <span class="order-info-label">赠品信息：</span>
              <span>{{ detailData.orderInfo.giftDetail }}</span>
            </div>
            <div class="order-info-item">
              <span class="order-info-label">单据来源：</span>
              <span>{{ detailData.orderInfo.source === '1' ? '手机端' : '客户端' }}</span>
            </div>
            <div class="order-info-item">
              <span class="order-info-label">订单性质：</span>
              <span>{{ detailData.orderInfo.orderTypeTitle }}</span>
            </div>
            <div class="order-info-item">
              <span class="order-info-label">销售单号：</span>
              <span>{{ detailData.orderInfo.orderNo }}</span>
            </div>
            <div class="order-info-item" v-if="detailData.orderInfo.originalInnerSn">
              <span class="order-info-label">原销售单号：</span>
              <span>{{ detailData.orderInfo.originalInnerSn }}</span>
            </div>
            <div class="order-info-item">
              <span class="order-info-label">外部单号：</span>
              <span>{{ detailData.orderInfo.outerSn }}</span>
            </div>
            <div class="order-info-item">
              <span class="order-info-label">业绩方式：</span>
              <span>{{detailData.orderInfo.brokerage === '1' ? '个人业绩' : detailData.orderInfo.brokerage === '4' ? '历练公单' : ''}}</span>
            </div>
            <div class="order-info-item" v-if="detailData.orderInfo.brokerage === '1' && detailData.orderInfo.shoppingGuideName">
              <span class="order-info-label">营业员：</span>
              <span>{{ detailData.orderInfo.shoppingGuideName }}</span>
            </div>
            <div class="order-info-item">
              <span class="order-info-label">创建时间：</span>
              <span>{{ detailData.orderInfo.createTime }}</span>
            </div>
            <div v-if="detailData.orderInfo.brokerage == 2 && detailData.orderInfo.shoppingGuideName" class="row" style="line-height: 20px; margin-top: 5px; width: 100%">
              <span class="order-info-label">班组人员：</span>
              <span class="description">{{ detailData.orderInfo.shoppingGuideName }}</span>
            </div>
            <div class="order-info-item" v-if="detailData.orderInfo.createTerminalTitle">
              <span class="order-info-label">创建订单收银台：</span>
              <span>{{ detailData.orderInfo.createTerminalTitle }}</span>
            </div>
            <div class="order-info-item" v-if="detailData.orderInfo.endTerminalTitle">
              <span class="order-info-label">结束订单收银台：</span>
              <span>{{ detailData.orderInfo.endTerminalTitle }}</span>
            </div>
          </div>
        </el-collapse-item>

        <el-collapse-item name="promotionInfo" v-if="detailData.promotionInfo && detailData.promotionInfo.length">
          <template slot="title">
            <div>
              <span class="title-text">促销信息</span>
            </div>
          </template>
          <template v-if="detailData.promotionInfo">
            <el-table
              border
              :data="detailData.promotionInfo"
              :header-cell-style="{background: '#FAFAFA', color: '#436481'}">
              <el-table-column prop="name" label="促销名称"></el-table-column>
              <el-table-column prop="type" label="促销类型"></el-table-column>
              <el-table-column prop="activityNo" label="促销编号"></el-table-column>
              <el-table-column prop="discountAmount" label="减扣金额">
                <template slot-scope="scope">
                  <div style="color: #F8475F;">***</div>
                </template>
              </el-table-column>
              <el-table-column prop="paymentState" label="促销单详情">
                <template slot-scope="scope">
                  <el-button type="text" @click="showDetail(scope.row)">查看详情</el-button>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-collapse-item>

        <el-collapse-item name="paymentInfo" v-if="(detailData.paymentInfo && detailData.paymentInfo.length) || (detailData.couponInfoList && detailData.couponInfoList.length)">
          <template slot="title">
            <div>
              <span class="title-text">收款信息</span>
            </div>
          </template>
          <div>
            <el-table
              border
              :data="detailData.paymentInfo"
              :header-cell-style="{background: '#FAFAFA', color: '#436481'}">
              <el-table-column prop="paymentName" label="收款方式"></el-table-column>
              <el-table-column prop="paymentPrice" label="收款金额">
                <template slot-scope="scope">
                  <div style="color: #F8475F;">***</div>
                </template>
              </el-table-column>
              <el-table-column prop="paymentState" label="支付状态">
                <template slot-scope="scope">
                  <el-tag
                    size="small"
                    effect="dark"
                    :type="
                      scope.row.paymentState == 0
                        ? 'primary'
                        : scope.row.paymentState == 1
                        ? 'success'
                        : scope.row.paymentState == 2
                        ? 'info'
                        : scope.row.paymentState == 3
                        ? 'danger'
                        : ''
                    ">
                    {{
                      scope.row.paymentState == 0
                        ? '已创建'
                        : scope.row.paymentState == 1
                        ? '已支付'
                        : scope.row.paymentState == 2
                        ? '已取消'
                        : scope.row.paymentState == 3
                        ? '支付中'
                        : ''
                    }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="createTime" label="创建时间" width="180"></el-table-column>
              <el-table-column prop="updateTime" label="更新时间"></el-table-column>
              <el-table-column prop="outerNo" label="支付凭证号"></el-table-column>
              <el-table-column prop="serialNumber" label="流水号"></el-table-column>
            </el-table>
            <el-table
              v-if="detailData.couponInfoList && detailData.couponInfoList.length"
              border
              style="margin-top: 10px;"
              :data="detailData.couponInfoList"
              :header-cell-style="{background: '#FAFAFA', color: '#436481'}">
              <el-table-column prop="name" label="优惠券名称"></el-table-column>
              <el-table-column prop="couponTypeName" label="优惠券类型" width="180"></el-table-column>
              <el-table-column prop="channelName" label="优惠券来源"></el-table-column>
              <el-table-column prop="actualDiscountAmount" label="优惠券金额">
                <template slot-scope="scope">
                  <div style="color: #F8475F;">***</div>
                </template>
              </el-table-column>
              <el-table-column prop="detail" label="操作">
                <template slot-scope="scope">
                  <div style="color: #077cf2; cursor: pointer" @click="detailOpen(scope.row)">
                    查看详情
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <ActiveDetail v-if="activeVisible" :promotionObj="propsData" @close="activeVisible = false"></ActiveDetail>
    <CouponDetail v-if="couponVisible" :dataInfo="propsData" @close="couponVisible = false"></CouponDetail>
  </el-dialog>
</template>

<script>
import {queryInvoicesInfo} from "@/libs/http/modules/posOrder"
import ActiveDetail from "./activeDetail.vue"
import CouponDetail from "./couponDetail.vue"
export default {
  name: 'orderDetail',
  components: {
    ActiveDetail,
    CouponDetail
  },
  props: {
    orderInfo: {
      type: Object,
      default: () => null
    }
  },
  data(){
    return {
      dialogVisible: true,
      fetchLoading: false,
      openList: ['storeInfo', 'orderInfo', 'promotionInfo', 'paymentInfo'],
      detailData: {},
      propsData: null,
      initCount: '',
      activeVisible: false,
      couponVisible: false,

      sell: require('@/assets/images/sell.png'),
      give: require('@/assets/images/give.png'),
      back: require('@/assets/images/return.png'),
      rite: require('@/assets/images/rite.png'),
      ned: require('@/assets/images/ned.png'),
      gridOption: {
        gridManagerName: 'goosInfo',
        firstLoading: false,
        height: 'auto',
        isCombSorting: true,
        supportAutoOrder: false,
        supportCheckbox: false,
        supportConfig: true,
        disableAutoLoading: true,
        supportMenu: false,
        disableBorder: true,
        disableLine: true,
        columnData: [
          {
            key: 'goodsNature',
            text: '类型',
            align: 'center',
            width: '70px',
            template: () => {
              return `
                <div>
                    <img style="width:40px;height:40px;" v-if="row.goodsNature === '1'" :src="sell" />
                    <img style="width:40px;height:40px;" v-if="row.goodsNature === '2'" :src="give" />
                    <img style="width:40px;height:40px;" v-if="row.goodsNature === '4'" :src="back" />
                    <img style="width:40px;height:40px;" v-if="row.goodsNature === '3'" :src="rite" />
                    <img style="width:40px;height:40px;" v-if="row.goodsNature === '6'" :src="ned" />
                </div>
              `
            }
          },
          {
            key: 'goodsName',
            text: '货品信息',
            align: 'center',
            width: '350px',
            template: () => {
              return `
                <div class="row align-cneter" style="text-align:left;">
                <div style="position:relative;overflow:hidden;width:102px;height:92px;border-radius:4px;">
                    <el-image v-if="row.goodsImg && row.goodsImg[0]" style="width:102px;height:92px;border-radius:4px;float:left;" :preview-src-list="row.goodsImg" :src="row.goodsImg[0]"></el-image>
                    <div v-else style="width:102px;height:92px;border-radius:4px;text-align:center;line-height:92px;color:#999;background:#f5f5f5;">暂无图片</div>
                    <div v-if="row.promoteActivityId || row.goodsNature === '2' || row.isAdd === 1 || row.dataType === 'other' || row.couponType"
                      style="width:70px;height:22px;line-height:22px;position:absolute;top:4px;right:-19px;transform: rotate(45deg);text-align:center;color:#fff;"
                      :style="row.isAdd === 1 ? 'background: linear-gradient(0deg, rgb(116,47,169), rgb(101,41,147), rgb(72,30,105))' : row.goodsNature === '2' ? 'background: linear-gradient(0deg, #208AEC, #02D7F0, #00C6F7)' : 'background: linear-gradient(-90deg, #EC4620, #F08702, #F7D400)'">
                      <span>{{row.isAdd === 1 ? '加购' : row.goodsNature === '2' ? '赠品' : (row.couponType || row.dataType === 'other') ? '核销' : '促销'}}</span>
                  </div>
                </div>
                <div class="column space-center" style="margin-left:10px;flex:1;width:170px;">
                    <div style="font-size:18px;color:#333;margin-top:-4px;">{{row.goodsName}}</div>
                    <div style="font-size:14px;color:#999;margin:4px 0;" v-if="row.dataType !== 'other'" >货号：{{row.goodsNo}}</div>
                    <div style="font-size:14px;color:#999;" v-if="row.dataType !== 'other'" >条码：{{row.barCode}}</div>
                    <div style="font-size:14px;color:#999;margin:4px 0;" v-else >货号：{{row.couponTypeDesc}}</div>
                </div>
                </div>
              `
            }
          },
          {
            key: 'colorDesc',
            text: '颜色 / 尺码',
            align: 'center',
            width: '150px',
            template: () => {
              return `
                <div v-if="row.attrList" class="row space-center align-center text-center" style="border:1px solid #DEEEF9;background:#fff;color:#333;line-height:26px;border-radius:2px;cursor:pointer;">
                  <p v-for="(item, index) in row.attrList.slice(0,2)" :key="item.code" style="">{{item.value}}
                      <span v-if="index == 0" style="margin:0 3px;">,</span>
                  </p>
                </div>
              `
            }
          },
          {
            key: 'number',
            text: '数量',
            align: 'center',
            width: '100px',
            template: () => {
              return `
                <div style="font-size:20px;">{{row.number}}</div>
              `
            }
          },
          {
            key: 'tagPrice',
            text: '吊牌价',
            width: '120px',
            align: 'center',
            template: () => {
              return `
                <div class="row align-center space-center">
                  <span v-if="row.tagPrice" style="font-size:20px;">￥{{row.tagPrice}}</span>
                </div>
              `
            }
          },
          {
            key: 'sellPrice',
            text: '零售价',
            width: '120px',
            align: 'center',
            template: () => {
              return `
                <div class="row align-center space-center">
                  <span v-if="row.sellPrice" style="font-size:20px;">***</span>
                </div>
              `
            }
          },
          {
            key: 'unitRealPrice',
            text: '实卖价(单价)',
            align: 'center',
            template: () => {
              return `
                <div class="row align-center space-center">
                  <span v-if="row.unitRealPrice" style="color:#666;font-size:20px;">***</span>
                </div>
              `
            }
          },
          {
            key: 'totalRealPrice',
            text: '金额(元)',
            align: 'center',
            template: () => {
              return `
                <div class="row align-cneter space-center" style="color:#F8475F;font-size:20px;">***</div>
              `
            }
          }
        ],
        ajaxData: this.showGoodsTable
      },
    }
  },
  created() {
    this.queryDetail()
  },
  methods: {
    closeDetail(){
      this.dialogVisible = false
      this.$emit('close')
    },
    queryDetail(){
      this.fetchLoading = true
      queryInvoicesInfo({
        orderId: this.orderInfo.id
      }).then(data => {
        this.detailData = data
        this.fetchLoading = false
        if (this.detailData.couponInfoList && this.detailData.couponInfoList.length) {
          let list = []
          this.detailData.couponInfoList.forEach(item => {
            if([1, 2].includes(item.couponType)) {
              list.push({
                goodsNature: '1',
                dataType: 'other',
                couponType: item.couponType,
                goodsName: item.couponTypeName,
                couponTypeDesc: item.name,
                goodsNo: item.name,
                number: item.number,
                tagPrice: item.tagPrice,
                sellPrice: item.sellPrice,
                unitRealPrice: item.retailPrice,
                certificateId: item.certificateId,
                couponInfoId: item.couponInfoId,
                totalRealPrice: item.totalRealPrice
              })
            }
          })
          this.detailData.storeInfo = this.detailData.storeInfo.concat(list)
        }
        GridManager.refreshGrid(this.gridOption.gridManagerName)
      }).catch(error => {
        this.fetchLoading = false
        this.$message({type: 'error', message: error, duration: 2000, showClose: true})
      })
    },
    showGoodsTable() {
      if (this.detailData.storeInfo && this.detailData.storeInfo.length) {
        this.initCount = this.detailData.storeInfo.reduce((prev, cur) => {
          return prev + Number(cur.number)
        }, 0)
        return new Promise((resolve, reject) => {
          const tableData = {
            data: this.detailData.storeInfo
          }
          resolve(tableData)
        })
      }
    },
    showDetail(data) {
      this.propsData = {
        ...data,
        orderId: this.orderInfo.id
      }
      this.activeVisible = true
    },
    detailOpen(data) {
      this.propsData = data
      this.couponVisible = true
    },
  }
}
</script>

<style lang="scss" scoped>
.content{
  height: 66vh;
  overflow: auto;
  margin: -20px 0 -30px;
  .title-text {
    padding-left: 10px;
    border-left: 4px solid #067cf2;
    font-size: 16px;
    height: 20px;
    display: flex;
    align-items: center;
    .title-item {
      margin-right: 10px;
    }
  }
  .order-info {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    .order-info-item {
      width: 33%;
    }
    .order-info-label {
      width: 70px;
      color: #999;
    }
    .red-text {
      color: red;
      font-size: 18px;
    }
  }
}
</style>